import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 element-ui
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn';

import $ from "jquery";

// 样式引入
import "./assets/index.scss";
// 引入iconfont
import "./assets/iconfont/iconfont.css";

const app = createApp(App);


app.use(store).use(ElementPlus, { locale }).use(router).use($).mount('#app')
